import React from 'react';
import { Box, Group, Image, Loader, Text } from '@mantine/core';
import { IconBrandDiscord, IconPlayerPlay } from '@tabler/icons-react';
import { THEME_COLORS } from '../../theme/ThemeConstants';

interface SidebarHeaderProps {
  playersOnline: number;
  discordOnline: number;
  logoUrl: string;
  isMinecraftLoading?: boolean;
  isDiscordLoading?: boolean;
  onServerClick?: () => void;
  onDiscordClick?: () => void;
}

export const SidebarHeader: React.FC<SidebarHeaderProps> = ({
  playersOnline,
  discordOnline,
  logoUrl,
  isMinecraftLoading = false,
  isDiscordLoading = false,
  onServerClick,
  onDiscordClick
}) => {
  return (
    <Group style={{ marginTop: 16, marginBottom: 24 }} justify='space-between' align='center' wrap='nowrap'>
      <Box
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 4,
          cursor: 'pointer',
          transition: 'opacity 0.2s ease'
        }}
        onClick={onServerClick}
        onMouseEnter={(e) => {
          e.currentTarget.style.opacity = '0.7';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.opacity = '1';
        }}
      >
        <Group gap={6} align='center' wrap='nowrap'>
          <IconPlayerPlay size={20} color={THEME_COLORS.text.primary} />
          <Text size='12px' fw={700} c='white' style={{ whiteSpace: 'nowrap' }}>
            Play Now
          </Text>
        </Group>
        <Box
          style={{
            backgroundColor: 'rgba(255, 255, 255, 0.05)',
            padding: '4px 8px',
            borderRadius: 4,
            minWidth: 80,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            border: '1px solid rgba(255, 255, 255, 0.06)'
          }}
        >
          {isMinecraftLoading ? (
            <Loader size={12} color={THEME_COLORS.accent.primary} />
          ) : (
            <Text size='xs' fw={700} c='white' style={{ whiteSpace: 'nowrap' }}>
              {playersOnline} ONLINE
            </Text>
          )}
        </Box>
      </Box>

      <Image src={logoUrl} alt='Server Logo' style={{ width: '56px', height: '56px' }} />

      <Box
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 4,
          cursor: 'pointer',
          transition: 'opacity 0.2s ease'
        }}
        onClick={onDiscordClick}
        onMouseEnter={(e) => {
          e.currentTarget.style.opacity = '0.7';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.opacity = '1';
        }}
      >
        <Group gap={6} align='center' wrap='nowrap'>
          <IconBrandDiscord size={20} color={THEME_COLORS.text.primary} />
          <Text size='12px' fw={700} c='white' style={{ whiteSpace: 'nowrap' }}>
            Discord
          </Text>
        </Group>
        <Box
          style={{
            backgroundColor: 'rgba(255, 255, 255, 0.05)',
            padding: '4px 8px',
            borderRadius: 4,
            minWidth: 80,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            border: '1px solid rgba(255, 255, 255, 0.06)'
          }}
        >
          {isDiscordLoading ? (
            <Loader size={12} color={THEME_COLORS.accent.primary} />
          ) : (
            <Text size='xs' fw={700} c='white' style={{ whiteSpace: 'nowrap' }}>
              {discordOnline} ONLINE
            </Text>
          )}
        </Box>
      </Box>
    </Group>
  );
};
